// you can import modules from the theme lib or even from
// NPM packages if they support it…
import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
const navMenu = require('./components/navMenu');
const scrollToTop = require('./components/scrollToTop');
const instagramFeed = require('./components/instagramFeed');


// Some convenient tools to get you started…
import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";


// Initialise our components on jQuery.ready…
jQuery(function ($) {
    navMenu.init();
    scrollToTop.init();
    instagramFeed.init();
});